<template>
  <div class="link" ref="linkArea">
    <div class="link-head">
      <span class="link-head-title">Your Link
        <a-segmented :value="linkInfo.linkType" :options="linkTypes" @change="(v) => emit('changeLinkType', v)">
          <template #label="{ value: val, disabled, payload }">
            <a-popover v-if="disabled" trigger="hover" :getPopupContainer="() => $refs.linkArea">
              <template #content>
                <span>This product does not support storefront link</span>
              </template>
              <span :class="val">{{ payload.content }}<i class="iconfont icon-wenhao-tianchong" /></span>
            </a-popover>
            <span v-else>{{ payload.content }}</span>
          </template>
        </a-segmented>
      </span>
      <span class="link-head-extra" v-if="sourceName"><strong>Source: </strong>{{ sourceName }}</span>
    </div>

    <div class="link-body" v-if="trackLinkId">
      <div class="link-scroll-area" v-if="linkInfo.linkType != 'associate'">
        <div class="link-textarea">
          <span class="link-copy-btn" @click="copyToClipboardText">
            <svg class="icon" aria-hidden="true" style="font-size: 22px">
              <use xlink:href="#icon-copy2"></use>
            </svg>
          </span>
          <template v-if="linkInfo.linkType == 'associate'">
            {{shortLinkSelect? associateShorLink : associateLink}}
          </template>
          <template v-else>
            {{ trackLink }}
          </template>
        </div>
      </div>
      <div class="link-scroll-area" v-if="linkInfo.linkType == 'associate'&&associateStatus == 'active'">
        <div class="link-textarea">
          <span class="link-copy-btn" @click="copyToClipboardText">
            <svg class="icon" aria-hidden="true" style="font-size: 22px">
              <use xlink:href="#icon-copy2"></use>
            </svg>
          </span>
          <template v-if="linkInfo.linkType == 'associate'">
            {{shortLinkSelect? associateShorLink : associateLink}}
          </template>
          <template v-else>
            {{ trackLink }}
          </template>
        </div>
      </div>
      <div class="link-scroll-area" v-if="linkInfo.linkType == 'associate'&&associateStatus != 'active'">
        <div class="link-textarea">
          <p class="link-new-text">The product is currently not eligible to participate in the associate program, and no commission will be paid by the brand.</p>
        </div>
      </div>
      <div class="link-opt" v-if="linkInfo.linkType != 'associate'">
        <artmisads-select-button @click="onShowLinkModal" >
          <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px;">
            <use xlink:href="#icon-jiahao"></use>
          </svg>
          Create New Link
        </artmisads-select-button>
        <a-space>
          <artmisads-select-button type="text" @click="showChartModal">
            <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px;">
              <use xlink:href="#icon-chart"></use>
            </svg>
            Performance
          </artmisads-select-button>
          <artmisads-select-button @click="() => onShowLinkModal(trackLinkId)">
            <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px;">
              <use xlink:href="#icon-bianji"></use>
            </svg>
            Edit Link
          </artmisads-select-button>
        </a-space>
      </div>
      <div class="link-opt" style="justify-content: flex-start;gap: 16px;" v-if="linkInfo.linkType == 'associate'&&associateStatus == 'active'">
    
        <a-checkbox
          :checked="shortLinkSelect"
           @update:checked="changeShortLinkSelect"
          >Short Link
        </a-checkbox>
        <!-- <artmisads-select-button @click="onShowLinkModal">
          <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px;">
            <use xlink:href="#icon-jiahao"></use>
          </svg>
          Create New Link
        </artmisads-select-button> -->
      </div>
    </div>
    <div class="link-body" v-else>
      <div class="link-new" v-if="linkInfo.linkType != 'associate'">
        <p>You have no saved links for this {{ linkInfo.linkType === 'product' ? 'Product' : 'Store' }}</p>
        <artmisads-select-button size="large" @click="onShowLinkModal" :disabled="status == 'inactive'">
          <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px;">
            <use xlink:href="#icon-jiahao-cu"></use>
          </svg>
          Create New Link
        </artmisads-select-button>
      </div>
       <div class="link-new" v-if="linkInfo.linkType == 'associate'&&associateStatus == 'active'">
        <p>You have no saved links for this {{ linkInfo.linkType === 'product' ? 'Product' : 'Store' }}</p>
        <artmisads-select-button size="large" @click="onShowLinkModal" :disabled="associateStatus == 'inactive'">
          <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px;">
            <use xlink:href="#icon-jiahao-cu"></use>
          </svg>
          Create New Link
        </artmisads-select-button>
      </div>
       <div class="link-new" v-if="linkInfo.linkType == 'associate'&&associateStatus != 'active'">
        <p class="link-new-text">The product is currently not eligible to participate in the associate program, and no commission will be paid by the brand.</p>
       </div>
    </div>
    <!-- 两种场景 -->
    <!-- 从未生成过Track Link的需要传productId -->
    <!-- 生成过Track Link的则需要传trackLinkId -->
    <LinkToolModal :productId="productId" :brandId="openModalParams.brandId" :trackLinkId="openTrackLinkId"
      :linkType="openModalParams.linkType" :countryCode="openModalParams.countryCode" v-model:open="open"
      @callback="onSaveCallback" :showAssociateTag="true"/>
    <lineChartModal v-if="showlineChartModal" :linkMd5="linkInfo.linkMd5 || updateLinkMd5" title="Link Performance"
      :itemInfo="itemInfo" :onCancleModal="onCancleChartModal"
      :pageType="'publisher' + (linkInfo.linkType == 'brand' ? 'Brand' : 'Link')" :marketplace="itemInfo.marketplace"
      defaultMetricName="detailPageViews"
      :noNeedList="['clicks', 'acosAmount', 'salesAmount', 'bonusAmount', 'commissionAndFeeAmount','quantity']" />
  </div>
</template>

<script setup>
import { ref, inject, watch } from 'vue'
import { copyToClipboard } from '~/utils'
import { publisherApi } from '~/server'
import LinkToolModal from './linkToolModal.vue'
import lineChartModal from '~/components/reports/lineChartModal.vue'
import { useUserInfoStore } from '~/storeData/index'

const store = useUserInfoStore()
const open = ref(false)
const itemInfo = ref(null)
const openModalParams = ref({})
const productId = inject('productId')
const showlineChartModal = ref(false)
const emit = defineEmits(['changeLinkType', 'updateLink'])

const props = defineProps(['info', 'brandDetail','associateStatus','status'])

const updateLinkMd5 = ref('')
const linkInfo = ref(props.info)
const trackLinkId = ref(linkInfo.value.id)
const trackLink = ref(linkInfo.value.value)
const sourceName = ref(linkInfo.value.source)
const associateLink = ref(linkInfo.value.associateLink)
const associateShorLink = ref(linkInfo.value.shortLink)
const shortLinkSelect = ref(linkInfo.value.shortLinkSelect)
const brandDetail = ref(props.brandDetail || null)
const openTrackLinkId = ref();
const linkTypes = ref([
  {
    value: 'product',
    payload: {
      content: 'Attribution Link'
    },
  
  },
  {
    value: 'brand',
    disabled: !linkInfo.value.amazonStoreHomePageUrl?.length,
    payload: {
      content: 'Storefront Link'
    }
  },
  // {
  //   value: 'associate',
  //   payload: {
  //     content: 'Associate Link'
  //   },
 
  // }
])
if(store.userInfo.associateEnabled == 'Y'){
  linkTypes.value=[
  {
    value: 'product',
    payload: {
      content: 'Attribution Link'
    },
     disabled: props.status == 'inactive',
  },
  {
    value: 'brand',
    disabled: !linkInfo.value.amazonStoreHomePageUrl?.length,
    payload: {
      content: 'Storefront Link'
    }
  },
  // {
  //   value: 'associate',
  //   payload: {
  //     content: 'Associate Link'
  //   },
  //   disabled: props.associateStatus == 'inactive',
  // }
  ]
}
else{
  linkTypes.value=[
    {
    value: 'product',
    payload: {
      content: 'Attribution Link'
    }
  },
  {
    value: 'brand',
    disabled: !linkInfo.value.amazonStoreHomePageUrl?.length,
    payload: {
      content: 'Storefront Link'
    }
  }
  ]
}

const showChartModal = () => {
  showlineChartModal.value = true;
  itemInfo.value = {
    id: linkInfo.value.id,
    value: linkInfo.value.value,
    countryCode: linkInfo.value.countryCode,
    source: linkInfo.value.source,
    linkMd5: linkInfo.value.linkMd5,
    productTitle: linkInfo.value.productTitle,
    productAsin: linkInfo.value.productAsin,
    productImageUrl: linkInfo.value.productImageUrl,
    marketplace: linkInfo.value.marketplace
  };

  if (linkInfo.value.linkType === 'brand') {
    itemInfo.value.biography = brandDetail.value.biography
    itemInfo.value.brandName = brandDetail.value.amazonBrandName
    itemInfo.value.brandLogoImageUrl = brandDetail.value.logoImageUrl
  }
}

const onCancleChartModal = () => {
  showlineChartModal.value = false;
  itemInfo.value = undefined;
}

const onShowLinkModal = (id) => {
  if (id && !id?.type) {
    openTrackLinkId.value = id;
  } else {
    openTrackLinkId.value = null;
  }

  openModalParams.value = {
    productId: productId?.value,
    brandId: linkInfo.value.brandId,
    linkType: linkInfo.value.linkType,
    countryCode: linkInfo.value.countryCode
  }
  open.value = true;
}

const onSaveCallback = updateData => {
  updateLinkMd5.value = updateData.linkMd5;
  sourceName.value = updateData.sourceName
  trackLinkId.value = updateData.trackLinkId;
  trackLink.value = updateData.shortLinkSelect ? updateData.shortLink : updateData.trackingLink;
  shortLinkSelect.value = updateData.shortLinkSelect
  associateLink.value = updateData?.associateLink
  associateShorLink.value = updateData?.shortLink
  emit('updateLink', linkInfo.value.linkType, updateData)
  open.value = false;
}
const changeShortLinkSelect = (val) => {
  shortLinkSelect.value = val
 
  // emit('updateLink', linkInfo.value.linkType, linkInfo.value)
}
const getBrandDetail = () => {
  if (!props.brandDetail) {
    publisherApi.getBrandDetail({ brandId: linkInfo.value.brandId }).then(res => {
      if (res.success) {
        brandDetail.value = res.data
      }
    })
  } else {
    brandDetail.value = props.brandDetail
  }
}
if (linkInfo.value.onlyShow) {
  linkTypes.value = linkTypes.value.filter(item => item.value === linkInfo.value.onlyShow)
}
const copyToClipboardText = () => {
  if(linkInfo.value.linkType == 'associate'){
    copyToClipboard(shortLinkSelect.value?associateShorLink.value: associateLink.value)
  }else{
    copyToClipboard(trackLink.value)
  }
}
watch(props.info, (newVal) => {
  linkInfo.value = newVal
  trackLinkId.value = newVal.id
  trackLink.value = newVal.value
  associateLink.value = newVal.associateLink
  associateShorLink.value = newVal.shortLink
  sourceName.value = newVal.source
  shortLinkSelect.value = newVal.shortLinkSelect
  getBrandDetail()
})
</script>

<style scoped lang="less">
.link {
  margin-top: 40px;

  .link-head {
    height: 28px;
    display: flex;
    line-height: 28px;
    margin: 16px 0 14px;
    align-items: center;
    justify-content: space-between;

    .link-head-title {
      gap: 12px;
      display: flex;
      font-size: 20px;
      font-weight: 600;
      align-items: center;
      color: var(--dark-1);
      letter-spacing: 0.5px;

      :deep(.ant-segmented) {
        font-weight: 500;
        border-radius: 9px;
        background: #EAE8F0;

        &-item {
          &:not(:last-child) {
            margin-right: 12px;
          }

          &-label {
            padding: 0 8px;
            font-size: 14px;
            font-weight: 600;
            user-select: none;
            border-radius: 6px;
            color: var(--dark-2);

            &:hover {
              background: #5040801a;
            }

            >.brand {
              display: flex;
              align-items: center;
            }

            .iconfont {
              width: auto;
              height: auto;
              font-size: 14px;
              margin-left: 3px;
            }
          }

          &-selected {
            color: var(--dark-1);
            box-shadow: 0 1px 0 0 #0f06290d;

            .ant-segmented-item-label {
              background: #fff;
              color: var(--dark-1);

              &:hover {
                background: #fff;
              }
            }
          }

          &-disabled {
            .ant-segmented-item-label {
              color: var(--dark-4);

              &:hover {
                background: #EAE8F0;
              }
            }
          }
        }
      }
    }

    .link-head-extra {
      letter-spacing: 0.4px;
      font-size: 14px;
      font-weight: 500;
      color: var(--dark-2);

      strong {
        font-weight: 400;
      }
    }
  }

  .link-body {
    position: relative;
    padding-bottom: 16px;

    .link-new {
      background-color: var(--bg-gray-2);
      border-radius: 8px;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      height: 160px;
      align-items: center;
      gap: 16px;
      width: 100%;
      .link-new-text{
        margin: 0 40px;
        
      }
      p {
        opacity: 0.7;
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        text-align: center;
        line-height: 22px;
      }

      button {
        display: inline-flex;
        align-items: center;
        font-weight: 500;
      }
    }

    .link-scroll-area {
      min-height: 80px;
      background-color: #EEEDF2;
      box-shadow: 0 1px 0 0 var(--box-shadow-2);
      border-radius: 8px;
      border: 1px solid #CCC7D9;
      box-sizing: border-box;
      padding: 8px 72px 7px 12px;
      line-height: 18px;
      word-break: break-word;
      color: var(--dark-2);

      .link-textarea {
        cursor: not-allowed;
        user-select: none;
        min-height: 58px;
        max-height: 84px;
        overflow-y: auto;
        .link-new-text{
          opacity: 0.7;
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        text-align: center;
        line-height: 22px;
        }
      }

      .link-copy-btn {
        cursor: pointer;
        display: block;
        position: absolute;
        right: 8px;
        top: 8px;
        display: flex;
        width: 56px;
        height: 64px;
        justify-content: center;
        align-items: center;
        background-color: var(--color-white);
        border-radius: 8px;

        svg {
          fill: var(--dark-3);
        }

        &:hover>svg {
          fill: var(--dark-2);
        }

        &:active>svg {
          fill: var(--dark-1);
        }
      }
    }

    .link-opt {
      margin-top: 16px;
      display: inline-flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      :deep(.ant-btn) {
        &.artmisads-select-button {
          display: flex;
          padding: 0 12px;
          line-height: 32px;
          align-items: center;
        }
      }
    }
  }
}

.source-edit {
  cursor: pointer;
  margin: 0 auto;
  display: flex;
  background-color: var(--bg-gray-1);
  width: 260px;
  height: 32px;
  justify-content: center;
  gap: 8px;
  align-items: center;
  border-radius: 8px;
  border: 1px dashed var(--border-1);
}
</style>